import { CaseClosingConfigurationDto } from 'types/caseClosing';
import { t } from 'utils/getTranslations';
import { CaseClosingSubsection, CaseClosingTick } from './CaseClosingSubsection';
import { useCaseClosingSubsectionEdit } from './useCaseClosingSubsectionEdit';

interface Props {
    caseClosing: CaseClosingConfigurationDto;
}

export function ClosingOnInvoiceSendSubsection({ caseClosing }: Props) {
    const { isEditMode, isSaving, startEditing, cancel, change, valueOf, save } =
        useCaseClosingSubsectionEdit(caseClosing);

    return (
        <CaseClosingSubsection
            titleId="case-closing-config.closing-on-invoice-send"
            isEditMode={isEditMode}
            isSaving={isSaving}
            onEdit={startEditing}
            onCancel={cancel}
            onSave={() => {
                void save();
            }}
        >
            <CaseClosingTick
                label={t('case-closing-config.allow-closing-on-invoice-send')}
                helperText={t('case-closing-config.allow-closing-on-invoice-send-helper')}
                checked={valueOf('isClosingOnInvoiceSendEnabled')}
                disabled={!isEditMode}
                onCheckedChange={(checked) => change({ isClosingOnInvoiceSendEnabled: checked })}
            />
        </CaseClosingSubsection>
    );
}
